// Dependencies
import React from 'react';

import PropTypes from 'prop-types';

import { Button } from '@nerdwallet/currency';
import { iconUri, cdnUri } from '@nerdwallet/nw-client-lib/cdn';

// Local components
import ImageSizes from '../../../../config/images/imageSizes';
import AuthModal from '../../../auth-modal/auth-modal';

// CSS
require('./recommendation.less');

const ContextualRecommendation = ({
  recommendation,
  howLongStay,
  isSignedIn,
}) => {
  let img = iconUri('iPad_graph');
  let title = 'Next steps';
  let content = 'See if you can get a better rate.';
  let location = '';
  let button = 'See rates';
  let showAuthModal = false;

  const imgUri = cdnUri('img/diy/hac', 'png');

  const flowConfig = {
    slides: [
      {
        copy: 'Get notified when you can save by refinancing.',
        image: imgUri('house-slider-bg-score'),
      },
      true,
      true,
    ],
  };

  switch (recommendation) {
    case 'yes':
      location = `/mortgages/refinance-rates?trk_source=mortgages_rc_greeninsight&trk_destination=refinance-rates&trk_origin=refinance-calculator&trk_app=tool&trk_content=rates_greeninsight_pos1&loanDuration=${howLongStay}`;
      break;

    case 'no':
      if (isSignedIn) {
        img = null;
        title = null;
        button = null;
        location = '/home/dashboard/home';
        content = (
          <span>
            NerdWallet will alert you in your{' '}
            <a href={location} target="_blank">
              feed
            </a>{' '}
            when you may be able to save money by refinancing.
          </span>
        );
      } else {
        showAuthModal = true;
        content =
          'NerdWallet will notify you when you may be able to save money by refinancing.';
        button = 'Get started';
      }

      break;

    // should never happen
    default:
      break;
  }

  const recommendationContent = (
    <div className="contextual-recommendation-wrapper">
      <div className="contextual-recommendation-wrapper-content">
        {title ? (
          <p className="contextual-recommendation-wrapper-content-title">
            {title}
          </p>
        ) : null}
        <p className="contextual-recommendation-wrapper-content-body">
          {img ? (
            <img src={img} {...ImageSizes.largeIcon.measures} alt="" />
          ) : null}
          {content}
        </p>
      </div>

      {button ? (
        <Button primary className="contextual-recommendation-wrapper-cta">
          {button}
        </Button>
      ) : null}
    </div>
  );

  return (
    <div className={`contextual-recommendation ${recommendation}`}>
      {showAuthModal ? (
        <AuthModal flow="basic" flowConfig={flowConfig} tracking="save_refi">
          {recommendationContent}
        </AuthModal>
      ) : (
        <div>
          {recommendationContent}
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label -- directive added automatically by Shepherd migration */}
          <a
            className="contextual-recommendation-link"
            href={location}
            target="_blank"
          />
        </div>
      )}
    </div>
  );
};

ContextualRecommendation.displayName = 'ContextualRecommendation';

ContextualRecommendation.propTypes = {
  recommendation: PropTypes.oneOf(['yes', 'no']).isRequired,
  howLongStay: PropTypes.number.isRequired,
  isSignedIn: PropTypes.bool.isRequired,
};

export default ContextualRecommendation;
